import { render, staticRenderFns } from "./videos-list.vue?vue&type=template&id=12ec1244&scoped=true&"
import script from "./videos-list.vue?vue&type=script&lang=js&"
export * from "./videos-list.vue?vue&type=script&lang=js&"
import style0 from "./videos-list.vue?vue&type=style&index=0&id=12ec1244&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ec1244",
  null
  
)

export default component.exports